import axiosInstance from 'api/axiosInstance';
export interface CANtrackCaseRaw {
	Id: string;
	Title: string;
	Description: string;
	ConsultantId: string;
	ConsultantName: string;
	CustomerId: string;
	CustomerName: string;
	GroupId: string;
	GroupTitle: string;
	ProjectId: string;
	ProjectTitle: string;
	DeliverableId: string;
	DeliverableTitle: string;
	StatusId?: string;
	StatusTitle?: string;
	StatusComment?: string;
}

interface GetCasesResponse {
	totalCases: number;
	rawCases: CANtrackCaseRaw[];
}

async function getCases(filterPayload: any): Promise<GetCasesResponse> {
	const data = await axiosInstance.get(
		`/api/cantrackv3/ReadCases?payload=${JSON.stringify(filterPayload)}`,
	);
	if (!data || !data.data.Data)
		throw new Error('Failed to fetch timesheet entries');
	if (!data.data.TotalResults || !data.data.Data)
		throw new Error('Invalid data returned from server');
	return {
		totalCases: data.data.TotalResults,
		rawCases: data.data.Data,
	};
}

export default getCases;
